import script from "./electrical-parameters-config-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./electrical-parameters-config-dialog.vue?vue&type=script&setup=true&lang=js"

import "./electrical-parameters-config-dialog.vue?vue&type=style&index=0&id=5bbcaa84&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bbcaa84"]])

export default __exports__